import React from "react";
import MetricStatCard from "./MetricStatCard";
import { formatCurrencyUsd } from "../shared/utils/financeDisplay";

/**
 * Compact list summary for Rental Leases (filtered rows + expired KPI).
 * Uses platform `cards-wrapper--summary-compact`.
 */
export default function RentalLeaseSummaryStatCards({
  totalRent,
  leaseCount,
  expiredRent,
  expiredLeaseCount,
  style,
  className,
}) {
  const rent = Number(totalRent) || 0;
  const count = Number(leaseCount) || 0;
  const expired = Number(expiredRent) || 0;
  const expiredCount = Number(expiredLeaseCount) || 0;
  const label =
    count > 0 ? `Total Monthly Rent (${count.toLocaleString()})` : "Total Monthly Rent";
  const expiredLabel =
    expiredCount > 0
      ? `Expired Monthly Rent (${expiredCount.toLocaleString()})`
      : "Expired Monthly Rent";
  return (
    <div
      className={`cards-wrapper cards-wrapper--sm cards-wrapper--summary-compact${
        className ? ` ${className}` : ""
      }`}
      style={{ marginBottom: 8, ...style }}
      role="region"
      aria-label="Rental leases summary"
    >
      <MetricStatCard
        label={label}
        value={formatCurrencyUsd(rent)}
        valueStyle={{ color: "#2563eb" }}
      />
      <MetricStatCard
        label={expiredLabel}
        value={formatCurrencyUsd(expired)}
        valueStyle={{ color: "#dc2626" }}
      />
    </div>
  );
}
